import { Users } from "../modules";

export const UsersPage = () => {
  return <Users variant="system" />;
};
